document.addEventListener("DOMContentLoaded", () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof SplitText === 'undefined') {
        console.warn("GSAP or one of its required plugins (ScrollTrigger/SplitText) is missing for the tagline section.");
        return;
    }
    gsap.registerPlugin(SplitText);

    const taglineSections = document.querySelectorAll('.tagline-section');

    taglineSections.forEach(section => {
        const svgMask = section.querySelector('.tagline-section__bg-image');
        const headline = section.querySelector('.tagline-section__headline');

        if (!headline || !svgMask) return;

        const split = new SplitText(headline, { type: "words" });
        const words = split.words;

        gsap.set(words, { opacity: 0, scale: 0.95 });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "+=350%",
                pin: true,
                scrub: true,
                fastScrollEnd: true,
                invalidateOnRefresh: true,
            }
        });

        tl.to(svgMask, {
            '--mask-size': '600%',
            ease: 'power2.in',
            duration: 6,
        });

        tl.to(words, {
            opacity: 1,
            duration: 0.2,
            stagger: 3,
            ease: "power2.out"
        }, ">0.75");

        tl.to(words, {
            scale: 1,
            duration: 1,
            stagger: 3,
            ease: "back.out(2)"
        }, "<");

        tl.to({}, { duration: 3.5 });
    });

    // Refresh ScrollTrigger after all animations are initialized
    ScrollTrigger.refresh();
});